import * as tslib_1 from "tslib";
import * as React from 'react';
import ReadOnlyRecipient from 'owa-readonly-recipient-well/lib/components/ReadOnlyRecipient';
import changeFrom from 'owa-mail-compose-store/lib/actions/changeFrom';
import strings from 'owa-strings/owa-mail-strings';
import toggleFromContextMenu from 'owa-mail-compose-store/lib/actions/toggleFromContextMenu';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { observer } from 'mobx-react';
var styles = require('./ComposeTop.scss');
var ComposeFromMenu = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeFromMenu, _super);
    function ComposeFromMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggleFromContextMenu = function (event) {
            toggleFromContextMenu(_this.props.viewState);
        };
        _this.onChangeFrom = function (event, item) {
            changeFrom(_this.props.viewState, item.key);
        };
        return _this;
    }
    ComposeFromMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props.viewState, isFromContextMenuShown = _a.isFromContextMenuShown, from = _a.from;
        return (React.createElement("div", { className: styles.recipientWell, ref: function (ref) { return (_this.container = ref); } },
            React.createElement("div", { tabIndex: 0, onClick: this.onToggleFromContextMenu, className: styles.fromLabel }, strings.fromLabel),
            isFromContextMenuShown && (React.createElement(ContextualMenu, { shouldFocusOnMount: true, target: this.container, directionalHint: 4 /* bottomLeftEdge */, onDismiss: this.onToggleFromContextMenu, items: this.fromItems })),
            React.createElement(ReadOnlyRecipient, { key: from.email.EmailAddress, viewState: from, name: from.email.Name, emailAddress: from.email.EmailAddress, onlyShowEmail: true, className: styles.fromAddress, mailBoxType: from.email.MailboxType })));
    };
    ComposeFromMenu.prototype.getRootdiv = function () {
        return this.container;
    };
    Object.defineProperty(ComposeFromMenu.prototype, "fromItems", {
        get: function () {
            var _this = this;
            var viewState = this.props.viewState;
            var sendAsEmailAddresses = viewState.sendAsEmailAddresses, loadAliasActionStatus = viewState.loadAliasActionStatus;
            var menuItems = [];
            if (loadAliasActionStatus != 2 /* Finished */) {
                menuItems.push({
                    name: strings.loading,
                });
            }
            else if (sendAsEmailAddresses && sendAsEmailAddresses.length > 0) {
                sendAsEmailAddresses.forEach(function (sendAsAddress) {
                    menuItems.push({
                        name: sendAsAddress,
                        key: sendAsAddress,
                        onClick: _this.onChangeFrom,
                    });
                });
            }
            return menuItems;
        },
        enumerable: true,
        configurable: true
    });
    ComposeFromMenu = tslib_1.__decorate([
        observer
    ], ComposeFromMenu);
    return ComposeFromMenu;
}(React.Component));
export default ComposeFromMenu;
//# sourceMappingURL=ComposeFromMenu.js.map